class ImageUtils {
  dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this

    const mimeRemoved = dataURI.indexOf(",") === -1;

    if (!dataURI.length) throw new Error("Image data string is empty");

    var byteString = atob(mimeRemoved ? dataURI : dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = mimeRemoved ? "image/jpeg" : dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  mimeTypeRemove(dataURI) {
    const mimeRemoved = dataURI.indexOf(",") === -1;
    return mimeRemoved ? dataURI : dataURI.split(",")[1];
  }

  stringtoBlob(data) {
    if (!data.length) throw new Error("Image data string is empty");

    var ab = new ArrayBuffer(data.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i);
    }

    return new Blob([ab]);
  }

  base64toBlob(base64) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(base64.split(",")[1]);

    // separate out the mime component
    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  blobToBase64(blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  base64ToImage(base64, fn) {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = base64;

      image.style.position = "absolute";
      image.style.zIndex = "-1";
      image.style.opacity = "0";
      image.style.left = "0";
      image.style.top = "0";

      image.addEventListener("load", (e) => resolve(fn(e)));

      document.body.appendChild(image);
      setTimeout(() => {
        document.body.removeChild(image);
      }, 0);
    });
  }

  base64ToImageData(base64) {
    return this.base64ToImage(base64, (e) => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const { width, height } = e.target;

      if (canvas.width !== width) canvas.width = width;
      if (canvas.height !== height) canvas.height = height;
      context.drawImage(e.target, 0, 0);
      return context.getImageData(0, 0, width, height);
    });
  }

  base64ToImageElement(base64) {
    return this.base64ToImage(base64, (e) => e.target);
  }

  getImageData(element) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const [width, height] = this.getSize(element);
    if (!width || !height) return null;
    if (canvas.width !== width) canvas.width = width;
    if (canvas.height !== height) canvas.height = height;
    context.drawImage(element, 0, 0);
    const imageData = context.getImageData(0, 0, width, height);
    return imageData;
  }

  getSize(element) {
    if (element instanceof HTMLImageElement) {
      return [element.naturalWidth, element.naturalHeight];
    } else if (element instanceof HTMLVideoElement) {
      return [element.videoWidth, element.videoHeight];
    } else if (element instanceof HTMLCanvasElement) {
      return [element.naturalWidth, element.naturalHeight];
    }

    return [0, 0];
  }

  cropImage(element, face) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const { width, height, x, y } = face;

    canvas.width = width;
    canvas.height = height;
    context.drawImage(element, x, y, width, height, 0, 0, width, height);

    return canvas.toDataURL("image/jpeg");
  }
  /** canvas_crop 이미지 픽셀 데이터의 data url 리턴  */
  resizeImage(base64, size) {
    return this.base64ToImage(base64, (e) => {
      const originalWidth = e.target.width;
      const originalHeight = e.target.height;

      const ratio = size / originalWidth;
      const newWidth = size;
      const newHeight = originalHeight * ratio;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = newWidth;
      canvas.height = newHeight;

      context.drawImage(e.target, 0, 0, newWidth, newHeight);

      return canvas.toDataURL("image/jpeg");
    });
  }
}

export default new ImageUtils();
